import instance from "../utils/network";

export function pushRegister(push: any): Promise<any> {
  return instance.post("/nest/push/register", push);
}

export function deletePushToken(): Promise<any> {
  return instance.delete("/nest/push/remove-push-token");
}

export function setNotificationAlert(isNotification: boolean): Promise<any> {
  return instance.patch(
    `/nest/push/club-chat-notification?isNotification=${isNotification}`
  );
}

export function setSocialNotificationAlert(
  roomId: number,
  isMuted: boolean
): Promise<any> {
  return instance.post(`/nest/push/game-chat-muted`, {
    roomId,
    isMuted,
  });
}

export function getSocialNotificationAlert(
  roomId: number
): Promise<{ isMuted: boolean }> {
  return instance.get(`/nest/push/game-chat-muted/${roomId}`);
}

export function getNotificationAlert(): Promise<{
  isNotification: boolean | null;
}> {
  return instance.get("/nest/push/club-chat-notification");
}
